import Product from './Product.vue'

export default Product
